import { useCallback, useRef, useState } from "react";
import { Button, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "../styles/registration.scss";
import { RegistrationStep1, RegistrationStep2 } from "../components";
import { registration, setFilters } from "../components/api";
import { setNotificationMessage, setShowNotification } from "../store";

const steps = [{
    component: (props) => <RegistrationStep1 {...props} />,
    apiFunction: (data) => registration(data)
},
{
    component: (props) => <RegistrationStep2 {...props} />,
    apiFunction: (data) => setFilters(data)
}];

export const Registration = () => {
    const formDataRef = useRef(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [isFormValid, setIsFormValid] = useState(false);
    const [resposeData, setResponseData] = useState(null);

    const handleSetIsFormValid = useCallback((valid) => {
        setIsFormValid(valid);
    }, []);

    const login = () => {
        window.location.href = "/authorization";
    }

    const continueButtonClick = () => {
        if (formDataRef.current) {
            const data = formDataRef.current.getData();
                
            steps[currentStep].apiFunction(data)
                .then(data => {
                    setResponseData(data);
                    if (currentStep < steps.length - 1) {
                        setCurrentStep(currentStep + 1);
                        setIsFormValid(false);
                    }
                    else {
                        document.location.href = "/registrationFinal";
                    }
                })
                .catch(error => {
                    const errorMessageData = error?.response?.data?.errors;
                    setNotificationMessage(errorMessageData
                        ? Array.from(errorMessageData).join(", ")
                        : "Произошла непредвиденная ошибка");
                    setShowNotification(true);
                });
        }
    }

    const CurrentStepComponent = steps[currentStep].component;

    return (
        <div className="registration">
            <div className="registration__head">
                <div className="registration__info">
                    <h2>Регистрация</h2>
                    <p style={{ color: "#646464ff" }}>Шаг {currentStep + 1}/{steps.length}</p>
                </div>

                <IconButton onClick={() => login()}>
                    <CloseIcon />
                </IconButton>
            </div>
            <CurrentStepComponent
                setIsFormValid={handleSetIsFormValid}
                ref={formDataRef}
                additionalData={resposeData}
            />
            <Button variant="contained" disabled={!isFormValid} onClick={() => continueButtonClick()}>Продолжить</Button>
        </div>
    );
}